import {Injectable} from '@angular/core';
import {TileLayer} from '@6grain/masofa-monolith-api-client/map/model/tileLayer';
import {Crop} from '@6grain/masofa-monolith-api-client/dictionaries';

@Injectable({
  providedIn: 'root'
})
export class CropsManagerService {

  private static readonly BASE_TEMP_LAYERS = [
    'SumOfActiveTemperaturesBase5',
    'SumOfActiveTemperaturesBase7',
    'SumOfActiveTemperaturesBase10',
    'SumOfActiveTemperaturesBase12',
    'SumOfActiveTemperaturesBase15'
  ];

  private static readonly CROP_TEMP_MAP: Record<string, number> = {
    'wheat': 5,
    'cotton': 12,
    'rice': 12,
    'beans': 15,
    'peppers': 15,
    'cucumbers': 15,
    'pomegranates': 15
  };

  private static readonly DEFAULT_TEMP = 10;

  static filterBaseTempByCrop(weatherLayerOptions: TileLayer[], cropId: string, crops: Crop[]): TileLayer[] {
    const crop = crops.find(c => c.id === cropId);
    const cropName = crop?.names?.['en-US']?.toLowerCase() ?? '';

    const baseTemp = this.CROP_TEMP_MAP[cropName] ?? this.DEFAULT_TEMP;
    const allowedLayer = `SumOfActiveTemperaturesBase${baseTemp}`;

    return weatherLayerOptions.filter(layer => {
      // Check geoServerName first, fallback to names
      const layerIdentifier = (layer as any).geoServerName ?? layer.names?.['en-US'] ?? '';

      // Check if this layer is one of the base temperature layers
      const matchedBaseTempLayer = this.BASE_TEMP_LAYERS.find(base => layerIdentifier.includes(base));

      if (!matchedBaseTempLayer) {
        return true; // Keep non-base-temp layers
      }

      // Only keep the layer if it matches the allowed temperature for this crop
      return layerIdentifier.includes(allowedLayer);
    });
  }
}
